module.exports = __webpack_public_path__ + "img/0Q3B2213_Wood.1a0b773e.jpg";